declare module '@mui/material/Chip' {
  interface ChipOwnProps {
    disableRipple?: boolean
  }
}

const MuiChip = {}

export default MuiChip
